
<div class="lead completed-panel" *ngIf="!processing">
    <div *ngFor="let question of  questions$ | async" >
      <p [innerHtml]="question.QuestionText"></p> 
  </div> 
</div>

<div *ngIf="processing"><h1 class="text-center">We are currently processing your application. This may take several minutes.</h1>
  <div class="spinner-wrapper text-center show">  
  <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  </div>
</div>